<template>
  <div>
    <div class="field">
      <label>AFメモ</label>
      <textarea v-model="form.model.concierge_memo"></textarea>
      <validation-message :form="form" :field="'concierge_memo'"></validation-message>
    </div>
    <div class="fields">
      <div class="required field">
        <label>ステータス</label>
        <div class="fields">
          <div class="field">
            <div class="ui checkbox radio">
              <input v-model="form.model.is_public" type="radio" name="is_publick" :value="'true'">
              <label>公開</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox radio">
              <input v-model="form.model.is_public" type="radio" name="is_publick" :value="'false'">
              <label>非公開</label>
            </div>
          </div>
        </div>
        <validation-message :form="form" :field="'is_public'"></validation-message>
      </div>
      <div class="required field">
        <label>ランク</label>
        <div class="fields">
          <div v-for="rank in consts.SHOP_RANK" :key="rank.value" class="field">
            <div class="ui checkbox radio">
              <input v-model="form.model.rank" type="radio" name="rank" :value="rank.value">
              <label>{{ rank.label }}</label>
            </div>
          </div>
        </div>
        <validation-message :form="form" :field="'rank'"></validation-message>
      </div>
      <div class="required field">
        <label>グルプラおすすめ表示</label>
        <div class="fields">
          <div class="field">
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.is_recommended" name="is_recommended" value="true">
              <label>表示する</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.is_recommended" name="is_recommended" value="false">
              <label>表示しない</label>
            </div>
          </div>
        </div>
        <validation-message :form="form" :field="'is_recommended'"></validation-message>
      </div>
      <div class="required field">
        <label>上位PR</label>
        <div class="fields">
          <div class="field">
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.is_promotion" name="is_promotion" :value="true">
              <label>表示する</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox radio">
              <input type="radio" v-model="form.model.is_promotion" name="is_promotion" :value="false">
              <label>表示しない</label>
            </div>
          </div>
        </div>
        <validation-message :form="form" :field="'is_promotion'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide required field">
        <label>契約サービス</label>
        <div class="ui checkbox">
          <input type="checkbox" v-model="form.model.is_banquet" :value="true">
          <label>宴会・パーティー</label>
        </div>
        <div class="ui checkbox">
          <input type="checkbox" v-model="form.model.is_meeting" :value="true">
          <label>会議室</label>
        </div>
        <div class="ui checkbox">
          <input type="checkbox" v-model="form.model.is_lodge_meeting" :value="true">
          <label>宿泊会議</label>
        </div>
        <validation-message :form="form" :field="'contract_services'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="four wide field">
        <label>請求対象</label>
        <input type="text" v-model="form.model.billing_subject" placeholder="税込総額">
        <validation-message :form="form" :field="'billing_subject'"></validation-message>
      </div>
      <div class="required four wide field">
        <label>手数料率</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.charge_rate" placeholder="10">
          <label class="ui label">%</label>
        </div>
        <validation-message :form="form" :field="'charge_rate'"></validation-message>
      </div>
      <div class="four wide field">
        <label>請求対象(会議室)</label>
        <input v-model="form.model.billing_subject_meeting">
        <validation-message :form="form" :field="'billing_subject_meeting'"></validation-message>
      </div>
      <div class="four wide field">
        <label>手数料率(会議室)</label>
        <div class="ui right labeled input">
          <input type="number" v-model="form.model.charge_rate_meeting" placeholder="10">
          <label class="ui label">%</label>
        </div>
        <validation-message :form="form" :field="'charge_rate_meeting'"></validation-message>
      </div>
    </div>
    <div class="fields">
      <div class="eight wide field">
        <label>グループ</label>
        <dropdown v-model="form.model.group" :placeholder="'グループ'">
          <option value="">なし</option>
          <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
        </dropdown>
      </div>
      <div class="eight wide field">
        <label>企業名</label>
        <input type="text" v-model="form.model.company_name">
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        form: {
            required: true
        }
    },
    data: function() {
        return {
            groups: [],
        };
    },
    created: function() {
        this.createForm().get('/afadmin/api/groups', function(response) {
            this.groups = response.data;
        }.bind(this));
    },
};
</script>
